/* tslint:disable */
/* eslint-disable */
/**
 * WebCore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { APAADMINAPIControllersPageSlugChangeRequest } from '../Models';
// @ts-ignore
import type { APAADMINBaseModelsContentListResponse } from '../Models';
// @ts-ignore
import type { APAADMINBaseModelsPageTreeResponse } from '../Models';
// @ts-ignore
import type { APAADMINBaseModelsPageTreeSearchResponse } from '../Models';
// @ts-ignore
import type { APAADMINBaseModelsPagesListResponse } from '../Models';
// @ts-ignore
import type { APAADMINBaseModelsSiteArchitectureResponse } from '../Models';
// @ts-ignore
import type { ContentDocument } from '../Models';
// @ts-ignore
import type { ContentQueryRequest } from '../Models';
// @ts-ignore
import type { ContentViewModel } from '../Models';
/**
 * ContentApi - axios parameter creator
 */
export const ContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentArchitectureGet: async (language?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/architecture`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentByIdGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/by-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [contentType] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentDeletedGet: async (page?: number, pageSize?: number, search?: string, contentType?: string, language?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/deleted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (contentType !== undefined) {
                localVarQueryParameter['contentType'] = contentType;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentDeploymentLinksGet: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/deployment-links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [pathPrefix] 
         * @param {string} [contentType] 
         * @param {string} [taxonomyIds] 
         * @param {string} [categoryId] 
         * @param {string} [sort] 
         * @param {boolean} [desc] 
         * @param {boolean} [includeLinks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentListGet: async (page?: number, pageSize?: number, search?: string, pathPrefix?: string, contentType?: string, taxonomyIds?: string, categoryId?: string, sort?: string, desc?: boolean, includeLinks?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (pathPrefix !== undefined) {
                localVarQueryParameter['pathPrefix'] = pathPrefix;
            }

            if (contentType !== undefined) {
                localVarQueryParameter['contentType'] = contentType;
            }

            if (taxonomyIds !== undefined) {
                localVarQueryParameter['taxonomyIds'] = taxonomyIds;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }

            if (includeLinks !== undefined) {
                localVarQueryParameter['includeLinks'] = includeLinks;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {APAADMINAPIControllersPageSlugChangeRequest} [aPAADMINAPIControllersPageSlugChangeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageChangeSlugPost: async (aPAADMINAPIControllersPageSlugChangeRequest?: APAADMINAPIControllersPageSlugChangeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/page/change-slug`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aPAADMINAPIControllersPageSlugChangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [language] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageDeletedGet: async (language?: string, page?: number, pageSize?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/page/deleted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [language] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [pathPrefix] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageListGet: async (language?: string, page?: number, pageSize?: number, search?: string, pathPrefix?: string, taxonomyIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/page/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (pathPrefix !== undefined) {
                localVarQueryParameter['pathPrefix'] = pathPrefix;
            }

            if (taxonomyIds !== undefined) {
                localVarQueryParameter['taxonomyIds'] = taxonomyIds;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageRestorePost: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/page/restore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [language] 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageTreeGet: async (language?: string, path?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/page/tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [language] 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageTreeSearchGet: async (language?: string, query?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/page/tree/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ContentQueryRequest} [contentQueryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentQueryPost: async (contentQueryRequest?: ContentQueryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contentQueryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentRestorePost: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/content/restore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {boolean} [summary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentSchemaKeyGet: async (schemaKey: string, summary?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaKey' is not null or undefined
            assertParamExists('apiContentSchemaKeyGet', 'schemaKey', schemaKey)
            const localVarPath = `/api/content/{schemaKey}`
                .replace('{schemaKey}', encodeURIComponent(String(schemaKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (summary !== undefined) {
                localVarQueryParameter['summary'] = summary;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentSchemaKeyLanguageGet: async (schemaKey: string, language: string, slug?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaKey' is not null or undefined
            assertParamExists('apiContentSchemaKeyLanguageGet', 'schemaKey', schemaKey)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('apiContentSchemaKeyLanguageGet', 'language', language)
            const localVarPath = `/api/content/{schemaKey}/{language}`
                .replace('{schemaKey}', encodeURIComponent(String(schemaKey)))
                .replace('{language}', encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {ContentDocument} [contentDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentSchemaKeyLanguagePut: async (schemaKey: string, language: string, slug?: string, contentDocument?: ContentDocument, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaKey' is not null or undefined
            assertParamExists('apiContentSchemaKeyLanguagePut', 'schemaKey', schemaKey)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('apiContentSchemaKeyLanguagePut', 'language', language)
            const localVarPath = `/api/content/{schemaKey}/{language}`
                .replace('{schemaKey}', encodeURIComponent(String(schemaKey)))
                .replace('{language}', encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contentDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentApi - functional programming interface
 */
export const ContentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentArchitectureGet(language?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsSiteArchitectureResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentArchitectureGet(language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentArchitectureGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentByIdGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentByIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentByIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [contentType] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentDeletedGet(page?: number, pageSize?: number, search?: string, contentType?: string, language?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsContentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentDeletedGet(page, pageSize, search, contentType, language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentDeletedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentDeploymentLinksGet(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentDeploymentLinksGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentDeploymentLinksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [pathPrefix] 
         * @param {string} [contentType] 
         * @param {string} [taxonomyIds] 
         * @param {string} [categoryId] 
         * @param {string} [sort] 
         * @param {boolean} [desc] 
         * @param {boolean} [includeLinks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentListGet(page?: number, pageSize?: number, search?: string, pathPrefix?: string, contentType?: string, taxonomyIds?: string, categoryId?: string, sort?: string, desc?: boolean, includeLinks?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsContentListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentListGet(page, pageSize, search, pathPrefix, contentType, taxonomyIds, categoryId, sort, desc, includeLinks, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {APAADMINAPIControllersPageSlugChangeRequest} [aPAADMINAPIControllersPageSlugChangeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentPageChangeSlugPost(aPAADMINAPIControllersPageSlugChangeRequest?: APAADMINAPIControllersPageSlugChangeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentPageChangeSlugPost(aPAADMINAPIControllersPageSlugChangeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentPageChangeSlugPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [language] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentPageDeletedGet(language?: string, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsPagesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentPageDeletedGet(language, page, pageSize, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentPageDeletedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [language] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [pathPrefix] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentPageListGet(language?: string, page?: number, pageSize?: number, search?: string, pathPrefix?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsPagesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentPageListGet(language, page, pageSize, search, pathPrefix, taxonomyIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentPageListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentPageRestorePost(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentPageRestorePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentPageRestorePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [language] 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentPageTreeGet(language?: string, path?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsPageTreeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentPageTreeGet(language, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentPageTreeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [language] 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentPageTreeSearchGet(language?: string, query?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsPageTreeSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentPageTreeSearchGet(language, query, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentPageTreeSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ContentQueryRequest} [contentQueryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentQueryPost(contentQueryRequest?: ContentQueryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContentDocument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentQueryPost(contentQueryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentQueryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentRestorePost(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentRestorePost(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentRestorePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {boolean} [summary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentSchemaKeyGet(schemaKey: string, summary?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContentDocument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentSchemaKeyGet(schemaKey, summary, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentSchemaKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentSchemaKeyLanguageGet(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentSchemaKeyLanguageGet(schemaKey, language, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentSchemaKeyLanguageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {ContentDocument} [contentDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContentSchemaKeyLanguagePut(schemaKey: string, language: string, slug?: string, contentDocument?: ContentDocument, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContentSchemaKeyLanguagePut(schemaKey, language, slug, contentDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContentApi.apiContentSchemaKeyLanguagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContentApi - factory interface
 */
export const ContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentArchitectureGet(language?: string, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsSiteArchitectureResponse> {
            return localVarFp.apiContentArchitectureGet(language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentByIdGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContentDocument> {
            return localVarFp.apiContentByIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [contentType] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentDeletedGet(page?: number, pageSize?: number, search?: string, contentType?: string, language?: string, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsContentListResponse> {
            return localVarFp.apiContentDeletedGet(page, pageSize, search, contentType, language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentDeploymentLinksGet(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiContentDeploymentLinksGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [pathPrefix] 
         * @param {string} [contentType] 
         * @param {string} [taxonomyIds] 
         * @param {string} [categoryId] 
         * @param {string} [sort] 
         * @param {boolean} [desc] 
         * @param {boolean} [includeLinks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentListGet(page?: number, pageSize?: number, search?: string, pathPrefix?: string, contentType?: string, taxonomyIds?: string, categoryId?: string, sort?: string, desc?: boolean, includeLinks?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsContentListResponse> {
            return localVarFp.apiContentListGet(page, pageSize, search, pathPrefix, contentType, taxonomyIds, categoryId, sort, desc, includeLinks, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {APAADMINAPIControllersPageSlugChangeRequest} [aPAADMINAPIControllersPageSlugChangeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageChangeSlugPost(aPAADMINAPIControllersPageSlugChangeRequest?: APAADMINAPIControllersPageSlugChangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContentViewModel> {
            return localVarFp.apiContentPageChangeSlugPost(aPAADMINAPIControllersPageSlugChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [language] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageDeletedGet(language?: string, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsPagesListResponse> {
            return localVarFp.apiContentPageDeletedGet(language, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [language] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [pathPrefix] 
         * @param {string} [taxonomyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageListGet(language?: string, page?: number, pageSize?: number, search?: string, pathPrefix?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsPagesListResponse> {
            return localVarFp.apiContentPageListGet(language, page, pageSize, search, pathPrefix, taxonomyIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageRestorePost(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiContentPageRestorePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [language] 
         * @param {string} [path] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageTreeGet(language?: string, path?: string, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsPageTreeResponse> {
            return localVarFp.apiContentPageTreeGet(language, path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [language] 
         * @param {string} [query] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentPageTreeSearchGet(language?: string, query?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsPageTreeSearchResponse> {
            return localVarFp.apiContentPageTreeSearchGet(language, query, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContentQueryRequest} [contentQueryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentQueryPost(contentQueryRequest?: ContentQueryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContentDocument>> {
            return localVarFp.apiContentQueryPost(contentQueryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentRestorePost(id?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiContentRestorePost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {boolean} [summary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentSchemaKeyGet(schemaKey: string, summary?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContentDocument>> {
            return localVarFp.apiContentSchemaKeyGet(schemaKey, summary, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentSchemaKeyLanguageGet(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContentViewModel> {
            return localVarFp.apiContentSchemaKeyLanguageGet(schemaKey, language, slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {ContentDocument} [contentDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContentSchemaKeyLanguagePut(schemaKey: string, language: string, slug?: string, contentDocument?: ContentDocument, options?: RawAxiosRequestConfig): AxiosPromise<ContentViewModel> {
            return localVarFp.apiContentSchemaKeyLanguagePut(schemaKey, language, slug, contentDocument, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContentApi - object-oriented interface
 */
export class ContentApi extends BaseAPI {
    /**
     * 
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentArchitectureGet(language?: string, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentArchitectureGet(language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentByIdGet(id?: string, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentByIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] 
     * @param {string} [contentType] 
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentDeletedGet(page?: number, pageSize?: number, search?: string, contentType?: string, language?: string, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentDeletedGet(page, pageSize, search, contentType, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentDeploymentLinksGet(id?: string, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentDeploymentLinksGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] 
     * @param {string} [pathPrefix] 
     * @param {string} [contentType] 
     * @param {string} [taxonomyIds] 
     * @param {string} [categoryId] 
     * @param {string} [sort] 
     * @param {boolean} [desc] 
     * @param {boolean} [includeLinks] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentListGet(page?: number, pageSize?: number, search?: string, pathPrefix?: string, contentType?: string, taxonomyIds?: string, categoryId?: string, sort?: string, desc?: boolean, includeLinks?: boolean, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentListGet(page, pageSize, search, pathPrefix, contentType, taxonomyIds, categoryId, sort, desc, includeLinks, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {APAADMINAPIControllersPageSlugChangeRequest} [aPAADMINAPIControllersPageSlugChangeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentPageChangeSlugPost(aPAADMINAPIControllersPageSlugChangeRequest?: APAADMINAPIControllersPageSlugChangeRequest, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentPageChangeSlugPost(aPAADMINAPIControllersPageSlugChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [language] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentPageDeletedGet(language?: string, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentPageDeletedGet(language, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [language] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] 
     * @param {string} [pathPrefix] 
     * @param {string} [taxonomyIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentPageListGet(language?: string, page?: number, pageSize?: number, search?: string, pathPrefix?: string, taxonomyIds?: string, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentPageListGet(language, page, pageSize, search, pathPrefix, taxonomyIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentPageRestorePost(id?: string, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentPageRestorePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [language] 
     * @param {string} [path] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentPageTreeGet(language?: string, path?: string, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentPageTreeGet(language, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [language] 
     * @param {string} [query] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentPageTreeSearchGet(language?: string, query?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentPageTreeSearchGet(language, query, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContentQueryRequest} [contentQueryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentQueryPost(contentQueryRequest?: ContentQueryRequest, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentQueryPost(contentQueryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentRestorePost(id?: string, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentRestorePost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} schemaKey 
     * @param {boolean} [summary] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentSchemaKeyGet(schemaKey: string, summary?: boolean, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentSchemaKeyGet(schemaKey, summary, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} schemaKey 
     * @param {string} language 
     * @param {string} [slug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentSchemaKeyLanguageGet(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentSchemaKeyLanguageGet(schemaKey, language, slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} schemaKey 
     * @param {string} language 
     * @param {string} [slug] 
     * @param {ContentDocument} [contentDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiContentSchemaKeyLanguagePut(schemaKey: string, language: string, slug?: string, contentDocument?: ContentDocument, options?: RawAxiosRequestConfig) {
        return ContentApiFp(this.configuration).apiContentSchemaKeyLanguagePut(schemaKey, language, slug, contentDocument, options).then((request) => request(this.axios, this.basePath));
    }
}

